// Tax numbers are shown as "65/604/07334" but stored without separators, so
// strip spaces, slashes and dots when what remains is all digits. Everything
// else (names, emails, UUIDs, "24/7 Services") is only trimmed. The backend
// cleans the input again.
export const cleanSearchInput = (value: string): string => {
  const trimmed = value.trim();
  const digits = trimmed.replace(/[\s./]/g, "");
  return /^\d+$/.test(digits) ? digits : trimmed;
};
